<template>
  <div class="editPolicy">
    <div class="title">编辑</div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="政策名称" prop="policyName">
          <el-input
            v-model="ruleForm.policyName"
            type="textarea"
            maxlength="500"
            show-word-limit
            rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="事项名称">
          <el-input
            type="textarea"
            v-model="ruleForm.content"
            maxlength="500"
            show-word-limit
            rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="行政区划">
          <el-select v-model="ruleForm.areaName" placeholder="行政区划">
            <el-option
              v-for="item in areaList"
              :key="item.county"
              :label="item.county"
              :value="item.county"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报开始时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.startTime"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="申报结束时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.endTime"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传附件">
          <el-upload
            class="upload-demo"
            :action="fileUpload"
            :headers="uploadHeader"
            :on-remove="handleRemove"
            multiple
            :limit="5"
            :on-exceed="handleExceed"
            :on-success="uploadSuccess"
            :file-list="fileList"
          >
            <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              支持扩展名：.xls .xlsx .doc .docx .pdf .jpg…最多5个
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitSave('ruleForm')"
            >保存</el-button
          >
          <el-button @click="goBack()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getToken } from '@utils'
import {
  getPolicyData,
  fileUpload,
  updatePolicyData
} from '@api/yardPolicy/policyManagement/index'
import { getArea } from '@api/common'
export default {
  name: 'EditPolicy',
  data() {
    return {
      fileUpload,
      ruleForm: {
        policyName: '',
        areaName: '',
        content: '',
        startTime: '',
        endTime: '',
        policyFileUrlList: []
      },
      rules: {
        policyName: [
          { required: true, message: '请输入政策名称', trigger: 'blur' },
          { min: 0, max: 500, message: '长度在0到500之间', trigger: 'blur' }
        ]
      },
      fileList: [],
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      areaList: []
    }
  },
  mounted() {
    this.getAreaList()
    if (this.$route.query.id) {
      this.getDetailData()
    }
  },
  methods: {
    getAreaList() {
      getArea().then((res) => {
        if (res.data.code === '0000') {
          this.areaList = res.data.data
        }
      })
    },
    getDetailData() {
      getPolicyData({ id: this.$route.query.id }).then((res) => {
        const { code, data, msg } = res.data
        if (res.data.code == '0000') {
          this.ruleForm = data
          this.fileList = []
          this.ruleForm.policyFileUrlList.map((item) => {
            this.fileList.push({ name: item.fileName, url: item.ossUrl })
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    submitSave(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          updatePolicyData({ id: this.$route.query.id, ...this.ruleForm }).then(
            (res) => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.goBack()
              }
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goBack() {
      this.$router.push('managementList')
    },
    handleExceed() {
      this.$message.warning('当前限制选择 5 个文件，已上传了5个文件')
    },
    handleRemove(file, fileList) {
      console.log(file)
      const index = this.ruleForm.policyFileUrlList.findIndex((item) => {
        return item.id == file.id
      })
      this.ruleForm.policyFileUrlList.splice(index, 1)
    },
    uploadSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.policyFileUrlList.push(response.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.editPolicy {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  .title {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
  }
  .content {
    padding: 30px 20px 20px;
  }
}
/deep/.el-date-editor {
  width: 50%;
  .el-input__inner {
    width: 100%;
  }
}
/deep/.el-form-item__content,
/deep/.el-input__inner {
  width: 50%;
}
/deep/.el-select {
  width: 50%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
